import * as React from 'react';
import RoundedButton, {ButtonType} from '../../elements/RoundedButton';
import Localized from 'src/constants/AppStrings';
type GiveCreditFooterProps = {
  onPress: () => void;
};

class GiveCreditFooter extends React.Component<GiveCreditFooterProps> {
  render() {
    return (
      <RoundedButton
        buttonType={ButtonType.action}
        onPress={this.props.onPress}
        accessibilityLabel="Add Credit"
        text={Localized.Labels.add_credit_to_machine}
      />
    );
  }
}

export default GiveCreditFooter;
